export default __webpack_public_path__ + "static/media/sobre.0563eec8.jpg";